export const SUPPORTED_LOCALES = ['en', 'ru'];
